const config = {
	api: 'https://navigate.ust.hk/path/api',
	asset: 'https://navigate.ust.hk/path/asset',
	// asset: 'https://forpathadvisor.blob.core.windows.net/base-map',
	loginTimeout: 18000000
};

export default config;
